export const formatNPWPValue = (value: string) => {
	const cleanedValue = value.replace(/[^\d]/g, '');
	let formattedValue = '';

	for (let i = 0; i < cleanedValue.length && i < 20; i++) {
		formattedValue += cleanedValue[i];
		if (i === 1 || i === 4 || i === 7 || i === 11) {
			formattedValue += '.';
		} else if (i === 8) {
			formattedValue += '-';
		}
	}
	return formattedValue;
};

export const formatCurrency = (value?: number, prefix: boolean = true) => {
	if (!value) return '0';
	const formattedValue = new Intl.NumberFormat('id-ID').format(value as number);
	if (prefix) return `${formattedValue}`;
	return formattedValue;
};

export const formatCurrencyWithDot = (
	value?: number,
	prefix: boolean = true,
) => {
	if (!value) return '0';
	const formattedValue = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 5,
	}).format(value as number);
	if (prefix) return `${formattedValue}`;
	return formattedValue;
};

export const thousandFormat = (value: string | number) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
